export default "__VITE_ASSET__CEfxcT5K__"